export default __webpack_public_path__ + "static/media/ESSP32ROSE01.72131b27.mp4";